export default __webpack_public_path__ + "static/media/sports3.fe667c38.jpg";